import { BrowserRouter, Routes } from 'react-router';
import * as Sentry from '@sentry/react'
import { NavRoutes } from './NavRoutes'
import { AdminRoutes } from './AdminRoutes'
import { ClientRoutes } from './ClientRoutes'
import { HelpCenterRoutes } from './HelpCenterRoutes'
import ModalWrapper from '../contexts/shared/components/modals/ModalWrapper'
import DesktopNotification from '../contexts/shared/components/DesktopNotification'
import ErrorBoundary from '../contexts/shared/components/layouts/ErrorBoundary'
import { DetailRoutes } from './DetailRoutes'

const myFallback = <ErrorBoundary />

const AppRouter = () => (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
    <Sentry.ErrorBoundary fallback={myFallback} showDialog>
    <Routes>
      {NavRoutes}
      {AdminRoutes}
      {ClientRoutes}
      {HelpCenterRoutes}
      {DetailRoutes}
    </Routes>

    <ModalWrapper />
    <DesktopNotification />
  </Sentry.ErrorBoundary>
  </BrowserRouter>
);

export default AppRouter;
